import { chakra } from '@chakra-ui/react';
import React from 'react';

interface Props {
  size?: number;
  className?: string;
}

const STROKE_PROPS = {
  stroke: '#14DCAC',
  strokeWidth: '1.8',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

const PATHS = [
  'M6.89062 9C7.87063 9.49 8.71062 10.23 9.32062 11.15C9.67062 11.67 9.67062 12.34 9.32062 12.86C8.71062 13.77 7.87063 14.51 6.89062 15',
  'M13 15H17',
  'M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z',
];

const DevelopersIcon = ({ className, size = 16 }: Props) => (
  <chakra.svg
    className={ className }
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    boxSize={ `${ size }px` }
    flexShrink={ 0 }
  >
    { PATHS.map((d) => <path key={ d } d={ d } { ...STROKE_PROPS }/>) }
  </chakra.svg>
);

export default DevelopersIcon;
